import * as k from "react";
import c, { useRef as fe, cloneElement as it, forwardRef as Te, useState as je, useImperativeHandle as Ke, useEffect as Ce, useContext as lt } from "react";
import { n as y, q as Ve, c as se, _ as ee, v as Ne, d as ve, R as We, E as ke, z as st, k as Me, P as Be, g as ut, m as ct } from "./CSSMotionList.js";
import { _ as we } from "./extends.js";
import { u as Pe, a as Ue } from "./useSize.js";
import { R as dt } from "./index5.js";
import { R as ft } from "./CloseCircleFilled.js";
import { b as Ge, u as vt, c as Fe, g as Ye, i as mt, a as pt } from "./index4.js";
import { d as De } from "./warning.js";
import { D as qe } from "./index.js";
import { a as Ze, u as Xe, F as Qe, C as Le } from "./ContextIsolator.js";
import { u as Je } from "./useVariants.js";
import { o as gt } from "./omit.js";
function xt(e) {
  return !!(e.addonBefore || e.addonAfter);
}
function ht(e) {
  return !!(e.prefix || e.suffix || e.allowClear);
}
function He(e, n, a) {
  var t = n.cloneNode(!0), o = Object.create(e, {
    target: {
      value: t
    },
    currentTarget: {
      value: t
    }
  });
  return t.value = a, typeof n.selectionStart == "number" && typeof n.selectionEnd == "number" && (t.selectionStart = n.selectionStart, t.selectionEnd = n.selectionEnd), t.setSelectionRange = function() {
    n.setSelectionRange.apply(n, arguments);
  }, o;
}
function ze(e, n, a, t) {
  if (a) {
    var o = n;
    if (n.type === "click") {
      o = He(n, e, ""), a(o);
      return;
    }
    if (e.type !== "file" && t !== void 0) {
      o = He(n, e, t), a(o);
      return;
    }
    a(o);
  }
}
function et(e, n) {
  if (e) {
    e.focus(n);
    var a = n || {}, t = a.cursor;
    if (t) {
      var o = e.value.length;
      switch (t) {
        case "start":
          e.setSelectionRange(0, 0);
          break;
        case "end":
          e.setSelectionRange(o, o);
          break;
        default:
          e.setSelectionRange(0, o);
      }
    }
  }
}
var tt = /* @__PURE__ */ c.forwardRef(function(e, n) {
  var a, t, o, u = e.inputElement, r = e.children, i = e.prefixCls, C = e.prefix, g = e.suffix, m = e.addonBefore, A = e.addonAfter, I = e.className, X = e.style, $ = e.disabled, U = e.readOnly, te = e.focused, G = e.triggerFocus, w = e.allowClear, F = e.value, ne = e.handleReset, S = e.hidden, s = e.classes, l = e.classNames, Y = e.dataAttrs, T = e.styles, _ = e.components, q = e.onClear, L = r ?? u, d = (_ == null ? void 0 : _.affixWrapper) || "span", Q = (_ == null ? void 0 : _.groupWrapper) || "span", j = (_ == null ? void 0 : _.wrapper) || "span", x = (_ == null ? void 0 : _.groupAddon) || "span", D = fe(null), f = function(ie) {
    var p;
    (p = D.current) !== null && p !== void 0 && p.contains(ie.target) && (G == null || G());
  }, ae = ht(e), M = /* @__PURE__ */ it(L, {
    value: F,
    className: y((a = L.props) === null || a === void 0 ? void 0 : a.className, !ae && (l == null ? void 0 : l.variant)) || null
  }), J = fe(null);
  if (c.useImperativeHandle(n, function() {
    return {
      nativeElement: J.current || D.current
    };
  }), ae) {
    var B = null;
    if (w) {
      var Z = !$ && !U && F, H = "".concat(i, "-clear-icon"), E = Ve(w) === "object" && w !== null && w !== void 0 && w.clearIcon ? w.clearIcon : "✖";
      B = /* @__PURE__ */ c.createElement("button", {
        type: "button",
        tabIndex: -1,
        onClick: function(ie) {
          ne == null || ne(ie), q == null || q();
        },
        onMouseDown: function(ie) {
          return ie.preventDefault();
        },
        className: y(H, se(se({}, "".concat(H, "-hidden"), !Z), "".concat(H, "-has-suffix"), !!g))
      }, E);
    }
    var O = "".concat(i, "-affix-wrapper"), ce = y(O, se(se(se(se(se({}, "".concat(i, "-disabled"), $), "".concat(O, "-disabled"), $), "".concat(O, "-focused"), te), "".concat(O, "-readonly"), U), "".concat(O, "-input-with-clear-btn"), g && w && F), s == null ? void 0 : s.affixWrapper, l == null ? void 0 : l.affixWrapper, l == null ? void 0 : l.variant), R = (g || w) && /* @__PURE__ */ c.createElement("span", {
      className: y("".concat(i, "-suffix"), l == null ? void 0 : l.suffix),
      style: T == null ? void 0 : T.suffix
    }, B, g);
    M = /* @__PURE__ */ c.createElement(d, we({
      className: ce,
      style: T == null ? void 0 : T.affixWrapper,
      onClick: f
    }, Y == null ? void 0 : Y.affixWrapper, {
      ref: D
    }), C && /* @__PURE__ */ c.createElement("span", {
      className: y("".concat(i, "-prefix"), l == null ? void 0 : l.prefix),
      style: T == null ? void 0 : T.prefix
    }, C), M, R);
  }
  if (xt(e)) {
    var V = "".concat(i, "-group"), P = "".concat(V, "-addon"), oe = "".concat(V, "-wrapper"), me = y("".concat(i, "-wrapper"), V, s == null ? void 0 : s.wrapper, l == null ? void 0 : l.wrapper), pe = y(oe, se({}, "".concat(oe, "-disabled"), $), s == null ? void 0 : s.group, l == null ? void 0 : l.groupWrapper);
    M = /* @__PURE__ */ c.createElement(Q, {
      className: pe,
      ref: J
    }, /* @__PURE__ */ c.createElement(j, {
      className: me
    }, m && /* @__PURE__ */ c.createElement(x, {
      className: P
    }, m), M, A && /* @__PURE__ */ c.createElement(x, {
      className: P
    }, A)));
  }
  return /* @__PURE__ */ c.cloneElement(M, {
    className: y((t = M.props) === null || t === void 0 ? void 0 : t.className, I) || null,
    style: ee(ee({}, (o = M.props) === null || o === void 0 ? void 0 : o.style), X),
    hidden: S
  });
}), St = ["show"];
function nt(e, n) {
  return k.useMemo(function() {
    var a = {};
    n && (a.show = Ve(n) === "object" && n.formatter ? n.formatter : !!n), a = ee(ee({}, a), e);
    var t = a, o = t.show, u = Ne(t, St);
    return ee(ee({}, u), {}, {
      show: !!o,
      showFormatter: typeof o == "function" ? o : void 0,
      strategy: u.strategy || function(r) {
        return r.length;
      }
    });
  }, [e, n]);
}
var bt = ["autoComplete", "onChange", "onFocus", "onBlur", "onPressEnter", "onKeyDown", "onKeyUp", "prefixCls", "disabled", "htmlSize", "className", "maxLength", "suffix", "showCount", "count", "type", "classes", "classNames", "styles", "onCompositionStart", "onCompositionEnd"], yt = /* @__PURE__ */ Te(function(e, n) {
  var a = e.autoComplete, t = e.onChange, o = e.onFocus, u = e.onBlur, r = e.onPressEnter, i = e.onKeyDown, C = e.onKeyUp, g = e.prefixCls, m = g === void 0 ? "rc-input" : g, A = e.disabled, I = e.htmlSize, X = e.className, $ = e.maxLength, U = e.suffix, te = e.showCount, G = e.count, w = e.type, F = w === void 0 ? "text" : w, ne = e.classes, S = e.classNames, s = e.styles, l = e.onCompositionStart, Y = e.onCompositionEnd, T = Ne(e, bt), _ = je(!1), q = ve(_, 2), L = q[0], d = q[1], Q = fe(!1), j = fe(!1), x = fe(null), D = fe(null), f = function(v) {
    x.current && et(x.current, v);
  }, ae = Pe(e.defaultValue, {
    value: e.value
  }), M = ve(ae, 2), J = M[0], B = M[1], Z = J == null ? "" : String(J), H = je(null), E = ve(H, 2), O = E[0], ce = E[1], R = nt(G, te), V = R.max || $, P = R.strategy(Z), oe = !!V && P > V;
  Ke(n, function() {
    var N;
    return {
      focus: f,
      blur: function() {
        var K;
        (K = x.current) === null || K === void 0 || K.blur();
      },
      setSelectionRange: function(K, Se, xe) {
        var ge;
        (ge = x.current) === null || ge === void 0 || ge.setSelectionRange(K, Se, xe);
      },
      select: function() {
        var K;
        (K = x.current) === null || K === void 0 || K.select();
      },
      input: x.current,
      nativeElement: ((N = D.current) === null || N === void 0 ? void 0 : N.nativeElement) || x.current
    };
  }), Ce(function() {
    j.current && (j.current = !1), d(function(N) {
      return N && A ? !1 : N;
    });
  }, [A]);
  var me = function(v, K, Se) {
    var xe = K;
    if (!Q.current && R.exceedFormatter && R.max && R.strategy(K) > R.max) {
      if (xe = R.exceedFormatter(K, {
        max: R.max
      }), K !== xe) {
        var ge, be;
        ce([((ge = x.current) === null || ge === void 0 ? void 0 : ge.selectionStart) || 0, ((be = x.current) === null || be === void 0 ? void 0 : be.selectionEnd) || 0]);
      }
    } else if (Se.source === "compositionEnd")
      return;
    B(xe), x.current && ze(x.current, v, t, xe);
  };
  Ce(function() {
    if (O) {
      var N;
      (N = x.current) === null || N === void 0 || N.setSelectionRange.apply(N, We(O));
    }
  }, [O]);
  var pe = function(v) {
    me(v, v.target.value, {
      source: "change"
    });
  }, ue = function(v) {
    Q.current = !1, me(v, v.currentTarget.value, {
      source: "compositionEnd"
    }), Y == null || Y(v);
  }, ie = function(v) {
    r && v.key === "Enter" && !j.current && (j.current = !0, r(v)), i == null || i(v);
  }, p = function(v) {
    v.key === "Enter" && (j.current = !1), C == null || C(v);
  }, b = function(v) {
    d(!0), o == null || o(v);
  }, re = function(v) {
    j.current && (j.current = !1), d(!1), u == null || u(v);
  }, z = function(v) {
    B(""), f(), x.current && ze(x.current, v, t);
  }, de = oe && "".concat(m, "-out-of-range"), Ee = function() {
    var v = gt(e, [
      "prefixCls",
      "onPressEnter",
      "addonBefore",
      "addonAfter",
      "prefix",
      "suffix",
      "allowClear",
      // Input elements must be either controlled or uncontrolled,
      // specify either the value prop, or the defaultValue prop, but not both.
      "defaultValue",
      "showCount",
      "count",
      "classes",
      "htmlSize",
      "styles",
      "classNames",
      "onClear"
    ]);
    return /* @__PURE__ */ c.createElement("input", we({
      autoComplete: a
    }, v, {
      onChange: pe,
      onFocus: b,
      onBlur: re,
      onKeyDown: ie,
      onKeyUp: p,
      className: y(m, se({}, "".concat(m, "-disabled"), A), S == null ? void 0 : S.input),
      style: s == null ? void 0 : s.input,
      ref: x,
      size: I,
      type: F,
      onCompositionStart: function(Se) {
        Q.current = !0, l == null || l(Se);
      },
      onCompositionEnd: ue
    }));
  }, Ae = function() {
    var v = Number(V) > 0;
    if (U || R.show) {
      var K = R.showFormatter ? R.showFormatter({
        value: Z,
        count: P,
        maxLength: V
      }) : "".concat(P).concat(v ? " / ".concat(V) : "");
      return /* @__PURE__ */ c.createElement(c.Fragment, null, R.show && /* @__PURE__ */ c.createElement("span", {
        className: y("".concat(m, "-show-count-suffix"), se({}, "".concat(m, "-show-count-has-suffix"), !!U), S == null ? void 0 : S.count),
        style: ee({}, s == null ? void 0 : s.count)
      }, K), U);
    }
    return null;
  };
  return /* @__PURE__ */ c.createElement(tt, we({}, T, {
    prefixCls: m,
    className: y(X, de),
    handleReset: z,
    value: Z,
    focused: L,
    triggerFocus: f,
    suffix: Ae(),
    disabled: A,
    classes: ne,
    classNames: S,
    styles: s,
    ref: D
  }), Ee());
});
const at = (e) => {
  let n;
  return typeof e == "object" && (e != null && e.clearIcon) ? n = e : e && (n = {
    clearIcon: /* @__PURE__ */ c.createElement(ft, null)
  }), n;
};
function Ct(e, n) {
  const a = fe([]), t = () => {
    a.current.push(setTimeout(() => {
      var o, u, r, i;
      !((o = e.current) === null || o === void 0) && o.input && ((u = e.current) === null || u === void 0 ? void 0 : u.input.getAttribute("type")) === "password" && (!((r = e.current) === null || r === void 0) && r.input.hasAttribute("value")) && ((i = e.current) === null || i === void 0 || i.input.removeAttribute("value"));
    }));
  };
  return Ce(() => (n && t(), () => a.current.forEach((o) => {
    o && clearTimeout(o);
  })), []), t;
}
function wt(e) {
  return !!(e.prefix || e.suffix || e.allowClear || e.showCount);
}
var Et = function(e, n) {
  var a = {};
  for (var t in e) Object.prototype.hasOwnProperty.call(e, t) && n.indexOf(t) < 0 && (a[t] = e[t]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var o = 0, t = Object.getOwnPropertySymbols(e); o < t.length; o++)
    n.indexOf(t[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, t[o]) && (a[t[o]] = e[t[o]]);
  return a;
};
const Rt = /* @__PURE__ */ Te((e, n) => {
  const {
    prefixCls: a,
    bordered: t = !0,
    status: o,
    size: u,
    disabled: r,
    onBlur: i,
    onFocus: C,
    suffix: g,
    allowClear: m,
    addonAfter: A,
    addonBefore: I,
    className: X,
    style: $,
    styles: U,
    rootClassName: te,
    onChange: G,
    classNames: w,
    variant: F
  } = e, ne = Et(e, ["prefixCls", "bordered", "status", "size", "disabled", "onBlur", "onFocus", "suffix", "allowClear", "addonAfter", "addonBefore", "className", "style", "styles", "rootClassName", "onChange", "classNames", "variant"]);
  if (process.env.NODE_ENV !== "production") {
    const {
      deprecated: z
    } = De("Input");
    z(!("bordered" in e), "bordered", "variant");
  }
  const {
    getPrefixCls: S,
    direction: s,
    allowClear: l,
    autoComplete: Y,
    className: T,
    style: _,
    classNames: q,
    styles: L
  } = ke("input"), d = S("input", a), Q = fe(null), j = Ze(d), [x, D, f] = Ge(d, te), [ae] = vt(d, j), {
    compactSize: M,
    compactItemClassnames: J
  } = Xe(d, s), B = Ue((z) => {
    var de;
    return (de = u ?? M) !== null && de !== void 0 ? de : z;
  }), Z = c.useContext(qe), H = r ?? Z, {
    status: E,
    hasFeedback: O,
    feedbackIcon: ce
  } = lt(Qe), R = Ye(E, o), V = wt(e) || !!O, P = fe(V);
  if (process.env.NODE_ENV !== "production") {
    const z = De("Input");
    Ce(() => {
      var de;
      V && !P.current && process.env.NODE_ENV !== "production" && z(document.activeElement === ((de = Q.current) === null || de === void 0 ? void 0 : de.input), "usage", "When Input is focused, dynamic add or remove prefix / suffix will make it lose focus caused by dom structure change. Read more: https://ant.design/components/input/#FAQ"), P.current = V;
    }, [V]);
  }
  const oe = Ct(Q, !0), me = (z) => {
    oe(), i == null || i(z);
  }, pe = (z) => {
    oe(), C == null || C(z);
  }, ue = (z) => {
    oe(), G == null || G(z);
  }, ie = (O || g) && /* @__PURE__ */ c.createElement(c.Fragment, null, g, O && ce), p = at(m ?? l), [b, re] = Je("input", F, t);
  return x(ae(/* @__PURE__ */ c.createElement(yt, Object.assign({
    ref: st(n, Q),
    prefixCls: d,
    autoComplete: Y
  }, ne, {
    disabled: H,
    onBlur: me,
    onFocus: pe,
    style: Object.assign(Object.assign({}, _), $),
    styles: Object.assign(Object.assign({}, L), U),
    suffix: ie,
    allowClear: p,
    className: y(X, te, f, j, J, T),
    onChange: ue,
    addonBefore: I && /* @__PURE__ */ c.createElement(Le, {
      form: !0,
      space: !0
    }, I),
    addonAfter: A && /* @__PURE__ */ c.createElement(Le, {
      form: !0,
      space: !0
    }, A),
    classNames: Object.assign(Object.assign(Object.assign({}, w), q), {
      input: y({
        [`${d}-sm`]: B === "small",
        [`${d}-lg`]: B === "large",
        [`${d}-rtl`]: s === "rtl"
      }, w == null ? void 0 : w.input, q.input, D),
      variant: y({
        [`${d}-${b}`]: re
      }, Fe(d, R)),
      affixWrapper: y({
        [`${d}-affix-wrapper-sm`]: B === "small",
        [`${d}-affix-wrapper-lg`]: B === "large",
        [`${d}-affix-wrapper-rtl`]: s === "rtl"
      }, D),
      wrapper: y({
        [`${d}-group-rtl`]: s === "rtl"
      }, D),
      groupWrapper: y({
        [`${d}-group-wrapper-sm`]: B === "small",
        [`${d}-group-wrapper-lg`]: B === "large",
        [`${d}-group-wrapper-rtl`]: s === "rtl",
        [`${d}-group-wrapper-${b}`]: re
      }, Fe(`${d}-group-wrapper`, R, O), D)
    })
  }))));
});
process.env.NODE_ENV !== "production" && (Rt.displayName = "Input");
var zt = `
  min-height:0 !important;
  max-height:none !important;
  height:0 !important;
  visibility:hidden !important;
  overflow:hidden !important;
  position:absolute !important;
  z-index:-1000 !important;
  top:0 !important;
  right:0 !important;
  pointer-events: none !important;
`, Nt = ["letter-spacing", "line-height", "padding-top", "padding-bottom", "font-family", "font-weight", "font-size", "font-variant", "text-rendering", "text-transform", "width", "text-indent", "padding-left", "padding-right", "border-width", "box-sizing", "word-break", "white-space"], Ie = {}, le;
function At(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, a = e.getAttribute("id") || e.getAttribute("data-reactid") || e.getAttribute("name");
  if (n && Ie[a])
    return Ie[a];
  var t = window.getComputedStyle(e), o = t.getPropertyValue("box-sizing") || t.getPropertyValue("-moz-box-sizing") || t.getPropertyValue("-webkit-box-sizing"), u = parseFloat(t.getPropertyValue("padding-bottom")) + parseFloat(t.getPropertyValue("padding-top")), r = parseFloat(t.getPropertyValue("border-bottom-width")) + parseFloat(t.getPropertyValue("border-top-width")), i = Nt.map(function(g) {
    return "".concat(g, ":").concat(t.getPropertyValue(g));
  }).join(";"), C = {
    sizingStyle: i,
    paddingSize: u,
    borderSize: r,
    boxSizing: o
  };
  return n && a && (Ie[a] = C), C;
}
function It(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, t = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
  le || (le = document.createElement("textarea"), le.setAttribute("tab-index", "-1"), le.setAttribute("aria-hidden", "true"), le.setAttribute("name", "hiddenTextarea"), document.body.appendChild(le)), e.getAttribute("wrap") ? le.setAttribute("wrap", e.getAttribute("wrap")) : le.removeAttribute("wrap");
  var o = At(e, n), u = o.paddingSize, r = o.borderSize, i = o.boxSizing, C = o.sizingStyle;
  le.setAttribute("style", "".concat(C, ";").concat(zt)), le.value = e.value || e.placeholder || "";
  var g = void 0, m = void 0, A, I = le.scrollHeight;
  if (i === "border-box" ? I += r : i === "content-box" && (I -= u), a !== null || t !== null) {
    le.value = " ";
    var X = le.scrollHeight - u;
    a !== null && (g = X * a, i === "border-box" && (g = g + u + r), I = Math.max(g, I)), t !== null && (m = X * t, i === "border-box" && (m = m + u + r), A = I > m ? "" : "hidden", I = Math.min(m, I));
  }
  var $ = {
    height: I,
    overflowY: A,
    resize: "none"
  };
  return g && ($.minHeight = g), m && ($.maxHeight = m), $;
}
var $t = ["prefixCls", "defaultValue", "value", "autoSize", "onResize", "className", "style", "disabled", "onChange", "onInternalAutoSize"], $e = 0, _e = 1, Oe = 2, _t = /* @__PURE__ */ k.forwardRef(function(e, n) {
  var a = e, t = a.prefixCls, o = a.defaultValue, u = a.value, r = a.autoSize, i = a.onResize, C = a.className, g = a.style, m = a.disabled, A = a.onChange, I = a.onInternalAutoSize, X = Ne(a, $t), $ = Pe(o, {
    value: u,
    postState: function(E) {
      return E ?? "";
    }
  }), U = ve($, 2), te = U[0], G = U[1], w = function(E) {
    G(E.target.value), A == null || A(E);
  }, F = k.useRef();
  k.useImperativeHandle(n, function() {
    return {
      textArea: F.current
    };
  });
  var ne = k.useMemo(function() {
    return r && Ve(r) === "object" ? [r.minRows, r.maxRows] : [];
  }, [r]), S = ve(ne, 2), s = S[0], l = S[1], Y = !!r, T = function() {
    try {
      if (document.activeElement === F.current) {
        var E = F.current, O = E.selectionStart, ce = E.selectionEnd, R = E.scrollTop;
        F.current.setSelectionRange(O, ce), F.current.scrollTop = R;
      }
    } catch {
    }
  }, _ = k.useState(Oe), q = ve(_, 2), L = q[0], d = q[1], Q = k.useState(), j = ve(Q, 2), x = j[0], D = j[1], f = function() {
    d($e), process.env.NODE_ENV === "test" && (I == null || I());
  };
  Me(function() {
    Y && f();
  }, [u, s, l, Y]), Me(function() {
    if (L === $e)
      d(_e);
    else if (L === _e) {
      var H = It(F.current, !1, s, l);
      d(Oe), D(H);
    } else
      T();
  }, [L]);
  var ae = k.useRef(), M = function() {
    Be.cancel(ae.current);
  }, J = function(E) {
    L === Oe && (i == null || i(E), r && (M(), ae.current = Be(function() {
      f();
    })));
  };
  k.useEffect(function() {
    return M;
  }, []);
  var B = Y ? x : null, Z = ee(ee({}, g), B);
  return (L === $e || L === _e) && (Z.overflowY = "hidden", Z.overflowX = "hidden"), /* @__PURE__ */ k.createElement(dt, {
    onResize: J,
    disabled: !(r || i)
  }, /* @__PURE__ */ k.createElement("textarea", we({}, X, {
    ref: F,
    style: Z,
    className: y(t, C, se({}, "".concat(t, "-disabled"), m)),
    disabled: m,
    value: te,
    onChange: w
  })));
}), Ot = ["defaultValue", "value", "onFocus", "onBlur", "onChange", "allowClear", "maxLength", "onCompositionStart", "onCompositionEnd", "suffix", "prefixCls", "showCount", "count", "className", "style", "disabled", "hidden", "classNames", "styles", "onResize", "onClear", "onPressEnter", "readOnly", "autoSize", "onKeyDown"], Ft = /* @__PURE__ */ c.forwardRef(function(e, n) {
  var a, t = e.defaultValue, o = e.value, u = e.onFocus, r = e.onBlur, i = e.onChange, C = e.allowClear, g = e.maxLength, m = e.onCompositionStart, A = e.onCompositionEnd, I = e.suffix, X = e.prefixCls, $ = X === void 0 ? "rc-textarea" : X, U = e.showCount, te = e.count, G = e.className, w = e.style, F = e.disabled, ne = e.hidden, S = e.classNames, s = e.styles, l = e.onResize, Y = e.onClear, T = e.onPressEnter, _ = e.readOnly, q = e.autoSize, L = e.onKeyDown, d = Ne(e, Ot), Q = Pe(t, {
    value: o,
    defaultValue: t
  }), j = ve(Q, 2), x = j[0], D = j[1], f = x == null ? "" : String(x), ae = c.useState(!1), M = ve(ae, 2), J = M[0], B = M[1], Z = c.useRef(!1), H = c.useState(null), E = ve(H, 2), O = E[0], ce = E[1], R = fe(null), V = fe(null), P = function() {
    var h;
    return (h = V.current) === null || h === void 0 ? void 0 : h.textArea;
  }, oe = function() {
    P().focus();
  };
  Ke(n, function() {
    var W;
    return {
      resizableTextArea: V.current,
      focus: oe,
      blur: function() {
        P().blur();
      },
      nativeElement: ((W = R.current) === null || W === void 0 ? void 0 : W.nativeElement) || P()
    };
  }), Ce(function() {
    B(function(W) {
      return !F && W;
    });
  }, [F]);
  var me = c.useState(null), pe = ve(me, 2), ue = pe[0], ie = pe[1];
  c.useEffect(function() {
    if (ue) {
      var W;
      (W = P()).setSelectionRange.apply(W, We(ue));
    }
  }, [ue]);
  var p = nt(te, U), b = (a = p.max) !== null && a !== void 0 ? a : g, re = Number(b) > 0, z = p.strategy(f), de = !!b && z > b, Ee = function(h, he) {
    var Re = he;
    !Z.current && p.exceedFormatter && p.max && p.strategy(he) > p.max && (Re = p.exceedFormatter(he, {
      max: p.max
    }), he !== Re && ie([P().selectionStart || 0, P().selectionEnd || 0])), D(Re), ze(h.currentTarget, h, i, Re);
  }, Ae = function(h) {
    Z.current = !0, m == null || m(h);
  }, N = function(h) {
    Z.current = !1, Ee(h, h.currentTarget.value), A == null || A(h);
  }, v = function(h) {
    Ee(h, h.target.value);
  }, K = function(h) {
    h.key === "Enter" && T && T(h), L == null || L(h);
  }, Se = function(h) {
    B(!0), u == null || u(h);
  }, xe = function(h) {
    B(!1), r == null || r(h);
  }, ge = function(h) {
    D(""), oe(), ze(P(), h, i);
  }, be = I, ye;
  p.show && (p.showFormatter ? ye = p.showFormatter({
    value: f,
    count: z,
    maxLength: b
  }) : ye = "".concat(z).concat(re ? " / ".concat(b) : ""), be = /* @__PURE__ */ c.createElement(c.Fragment, null, be, /* @__PURE__ */ c.createElement("span", {
    className: y("".concat($, "-data-count"), S == null ? void 0 : S.count),
    style: s == null ? void 0 : s.count
  }, ye)));
  var ot = function(h) {
    var he;
    l == null || l(h), (he = P()) !== null && he !== void 0 && he.style.height && ce(!0);
  }, rt = !q && !U && !C;
  return /* @__PURE__ */ c.createElement(tt, {
    ref: R,
    value: f,
    allowClear: C,
    handleReset: ge,
    suffix: be,
    prefixCls: $,
    classNames: ee(ee({}, S), {}, {
      affixWrapper: y(S == null ? void 0 : S.affixWrapper, se(se({}, "".concat($, "-show-count"), U), "".concat($, "-textarea-allow-clear"), C))
    }),
    disabled: F,
    focused: J,
    className: y(G, de && "".concat($, "-out-of-range")),
    style: ee(ee({}, w), O && !rt ? {
      height: "auto"
    } : {}),
    dataAttrs: {
      affixWrapper: {
        "data-count": typeof ye == "string" ? ye : void 0
      }
    },
    hidden: ne,
    readOnly: _,
    onClear: Y
  }, /* @__PURE__ */ c.createElement(_t, we({}, d, {
    autoSize: q,
    maxLength: g,
    onKeyDown: K,
    onChange: v,
    onFocus: Se,
    onBlur: xe,
    onCompositionStart: Ae,
    onCompositionEnd: N,
    className: y(S == null ? void 0 : S.textarea),
    style: ee(ee({}, s == null ? void 0 : s.textarea), {}, {
      resize: w == null ? void 0 : w.resize
    }),
    disabled: F,
    prefixCls: $,
    onResize: ot,
    ref: V,
    readOnly: _
  })));
});
const Dt = (e) => {
  const {
    componentCls: n,
    paddingLG: a
  } = e, t = `${n}-textarea`;
  return {
    // Raw Textarea
    [`textarea${n}`]: {
      maxWidth: "100%",
      // prevent textarea resize from coming out of its container
      height: "auto",
      minHeight: e.controlHeight,
      lineHeight: e.lineHeight,
      verticalAlign: "bottom",
      transition: `all ${e.motionDurationSlow}`,
      resize: "vertical",
      [`&${n}-mouse-active`]: {
        transition: `all ${e.motionDurationSlow}, height 0s, width 0s`
      }
    },
    // Wrapper for resize
    [`${n}-textarea-affix-wrapper-resize-dirty`]: {
      width: "auto"
    },
    [t]: {
      position: "relative",
      "&-show-count": {
        [`${n}-data-count`]: {
          position: "absolute",
          bottom: e.calc(e.fontSize).mul(e.lineHeight).mul(-1).equal(),
          insetInlineEnd: 0,
          color: e.colorTextDescription,
          whiteSpace: "nowrap",
          pointerEvents: "none"
        }
      },
      [`
        &-allow-clear > ${n},
        &-affix-wrapper${t}-has-feedback ${n}
      `]: {
        paddingInlineEnd: a
      },
      [`&-affix-wrapper${n}-affix-wrapper`]: {
        padding: 0,
        [`> textarea${n}`]: {
          fontSize: "inherit",
          border: "none",
          outline: "none",
          background: "transparent",
          minHeight: e.calc(e.controlHeight).sub(e.calc(e.lineWidth).mul(2)).equal(),
          "&:focus": {
            boxShadow: "none !important"
          }
        },
        [`${n}-suffix`]: {
          margin: 0,
          "> *:not(:last-child)": {
            marginInline: 0
          },
          // Clear Icon
          [`${n}-clear-icon`]: {
            position: "absolute",
            insetInlineEnd: e.paddingInline,
            insetBlockStart: e.paddingXS
          },
          // Feedback Icon
          [`${t}-suffix`]: {
            position: "absolute",
            top: 0,
            insetInlineEnd: e.paddingInline,
            bottom: 0,
            zIndex: 1,
            display: "inline-flex",
            alignItems: "center",
            margin: "auto",
            pointerEvents: "none"
          }
        }
      },
      [`&-affix-wrapper${n}-affix-wrapper-rtl`]: {
        [`${n}-suffix`]: {
          [`${n}-data-count`]: {
            direction: "ltr",
            insetInlineStart: 0
          }
        }
      },
      [`&-affix-wrapper${n}-affix-wrapper-sm`]: {
        [`${n}-suffix`]: {
          [`${n}-clear-icon`]: {
            insetInlineEnd: e.paddingInlineSM
          }
        }
      }
    }
  };
}, Tt = ut(["Input", "TextArea"], (e) => {
  const n = ct(e, mt(e));
  return [Dt(n)];
}, pt, {
  resetFont: !1
});
var Vt = function(e, n) {
  var a = {};
  for (var t in e) Object.prototype.hasOwnProperty.call(e, t) && n.indexOf(t) < 0 && (a[t] = e[t]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var o = 0, t = Object.getOwnPropertySymbols(e); o < t.length; o++)
    n.indexOf(t[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, t[o]) && (a[t[o]] = e[t[o]]);
  return a;
};
const qt = /* @__PURE__ */ Te((e, n) => {
  var a;
  const {
    prefixCls: t,
    bordered: o = !0,
    size: u,
    disabled: r,
    status: i,
    allowClear: C,
    classNames: g,
    rootClassName: m,
    className: A,
    style: I,
    styles: X,
    variant: $,
    showCount: U,
    onMouseDown: te,
    onResize: G
  } = e, w = Vt(e, ["prefixCls", "bordered", "size", "disabled", "status", "allowClear", "classNames", "rootClassName", "className", "style", "styles", "variant", "showCount", "onMouseDown", "onResize"]);
  if (process.env.NODE_ENV !== "production") {
    const {
      deprecated: p
    } = De("TextArea");
    p(!("bordered" in e), "bordered", "variant");
  }
  const {
    getPrefixCls: F,
    direction: ne,
    allowClear: S,
    autoComplete: s,
    className: l,
    style: Y,
    classNames: T,
    styles: _
  } = ke("textArea"), q = k.useContext(qe), L = r ?? q, {
    status: d,
    hasFeedback: Q,
    feedbackIcon: j
  } = k.useContext(Qe), x = Ye(d, i), D = k.useRef(null);
  k.useImperativeHandle(n, () => {
    var p;
    return {
      resizableTextArea: (p = D.current) === null || p === void 0 ? void 0 : p.resizableTextArea,
      focus: (b) => {
        var re, z;
        et((z = (re = D.current) === null || re === void 0 ? void 0 : re.resizableTextArea) === null || z === void 0 ? void 0 : z.textArea, b);
      },
      blur: () => {
        var b;
        return (b = D.current) === null || b === void 0 ? void 0 : b.blur();
      }
    };
  });
  const f = F("input", t), ae = Ze(f), [M, J, B] = Ge(f, m), [Z] = Tt(f, ae), {
    compactSize: H,
    compactItemClassnames: E
  } = Xe(f, ne), O = Ue((p) => {
    var b;
    return (b = u ?? H) !== null && b !== void 0 ? b : p;
  }), [ce, R] = Je("textArea", $, o), V = at(C ?? S), [P, oe] = k.useState(!1), [me, pe] = k.useState(!1), ue = (p) => {
    oe(!0), te == null || te(p);
    const b = () => {
      oe(!1), document.removeEventListener("mouseup", b);
    };
    document.addEventListener("mouseup", b);
  }, ie = (p) => {
    var b, re;
    if (G == null || G(p), P && typeof getComputedStyle == "function") {
      const z = (re = (b = D.current) === null || b === void 0 ? void 0 : b.nativeElement) === null || re === void 0 ? void 0 : re.querySelector("textarea");
      z && getComputedStyle(z).resize === "both" && pe(!0);
    }
  };
  return M(Z(/* @__PURE__ */ k.createElement(Ft, Object.assign({
    autoComplete: s
  }, w, {
    style: Object.assign(Object.assign({}, Y), I),
    styles: Object.assign(Object.assign({}, _), X),
    disabled: L,
    allowClear: V,
    className: y(
      B,
      ae,
      A,
      m,
      E,
      l,
      // Only for wrapper
      me && `${f}-textarea-affix-wrapper-resize-dirty`
    ),
    classNames: Object.assign(Object.assign(Object.assign({}, g), T), {
      textarea: y({
        [`${f}-sm`]: O === "small",
        [`${f}-lg`]: O === "large"
      }, J, g == null ? void 0 : g.textarea, T.textarea, P && `${f}-mouse-active`),
      variant: y({
        [`${f}-${ce}`]: R
      }, Fe(f, x)),
      affixWrapper: y(`${f}-textarea-affix-wrapper`, {
        [`${f}-affix-wrapper-rtl`]: ne === "rtl",
        [`${f}-affix-wrapper-sm`]: O === "small",
        [`${f}-affix-wrapper-lg`]: O === "large",
        [`${f}-textarea-show-count`]: U || ((a = e.count) === null || a === void 0 ? void 0 : a.show)
      }, J)
    }),
    prefixCls: f,
    suffix: Q && /* @__PURE__ */ k.createElement("span", {
      className: `${f}-textarea-suffix`
    }, j),
    showCount: U,
    ref: D,
    onResize: ie,
    onMouseDown: ue
  }))));
});
export {
  Rt as I,
  qt as T,
  Ct as u
};
